import React, { useState, useEffect } from "react";
import { Spinner, Table } from "reactstrap";

import "./TableDisplay.scss";

const TableDisplay = (props) => {
  const { containerClass, columns, tooltips, rows, loading, fixed = false } = props;
  const [headerData, setHeaderData] = useState(null);

  useEffect(() => {
    if (columns) {
      const tooltipsPresent = tooltips?.length === columns.length;
      const headerColumns = columns.map((column, index) => {
        if(tooltipsPresent && !!tooltips[index]) {
          return <th key={index}>
            <div className="table-display--header-elem">
              <div className="table-display--tooltip">
                <div className="table-display--tooltip-text">
                  {tooltips[index]}
                </div>
                <div className="table-display--tooltip-icon">
                  i
                </div>
              </div>
              {column}
            </div>
          </th> 
        }
        return <th key={index}>{column}</th>
      });
      setHeaderData(headerColumns);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  return (
    <React.Fragment>
      <div className={containerClass + " disabled-" + loading + " fixed-" + fixed}>
        <Table striped hover>
          <thead>
            <tr>{headerData}</tr>
          </thead>
          {fixed && (
            <colgroup>
              <col span="1" className="fixed-column" />
            </colgroup>
          )}
          {rows && rows.length > 0 && <tbody>{rows}</tbody>}
          {rows && rows.length === 0 && (
            <tbody>
              <tr className="no-records">
                <td>No records found</td>
              </tr>
            </tbody>
          )}
        </Table>
        {loading && <Spinner size="md" color="orange" />}
      </div>
    </React.Fragment>
  );
};

export default TableDisplay;
